<template>
  <div class="bb-approve-cell"
       @mouseenter="setPositionPopup($event, row._id, 'approveButton')"
       @mouseleave="showPopup = false"
  >
    <div class="bb-approve-cell-icons"
         v-if="!row.openEdit"
    >
      <img src="@/assets/images/icon-pencil.png"
           class="bb-approve-cell__icon"
           @click.stop="openEdit(index, row)"
           ref="approveButton"
      />
      <div v-if="row.isBonusBC"
           @click.stop="openDoubleKPI(index, row)"
           class="bb-approve-cell__double"
      >
        x2
      </div>
      <transition name="fade" mode="out-in">
        <div v-if="isHelpKPI && showPopup === row._id"
             :style="openPopup"
             class="bb-approve-cell-popup"
        >
            <span class="bb-approve-cell-popup__text">
              Pending with {{mainUser.username}}
            </span>
        </div>
      </transition>
    </div>
    <div class="bb-approve-cell-icons" v-else>
      <button class="bb-button bb-approve-cell__button"
              @click.stop="clickCell"
      >
        SAVE
      </button>
    </div>
  </div>
</template>

<script>
import {get, set} from 'lodash'
export default {
  name: 'ApproveCell',
  props: ['row', 'column', 'index'],
  data () {
    return {
      showBonusKPI: false,
      showPopup: false,
      openPopup: {
        left: 0,
        top: 0
      }
    }
  },
  computed: {
    value () {
      const fromProp = get(this.row, this.column.prop, '')
      return get(this.row, this.column.editable, fromProp)
    },
    isHelpKPI () {
      return get(this.row, 'isHelpKpi', false)
    },
    mainUser () {
      const kpiHelpUsers = get(this.row, ['project', 'kpiHelpUsers'], [])
      if (!kpiHelpUsers.length) return
      const mainUser = kpiHelpUsers.find(item => item.main)
      const {user} = mainUser
      return user
    }
  },
  methods: {
    openEdit (index, row) {
      if (this.isHelpKPI) return
      this.$set(row, 'openEdit', true)
      this.$emit('resetEditTable', row)
    },
    clickCell () {
      const action = get(this.column, 'action', '')
      if (action && typeof action === 'function') action(this.row, this.column)
    },
    openDoubleKPI (index, row) {
      if (this.isHelpKPI) return
      this.showBonusKPI = true
      this.$set(row, '$doubleKpi', true)
      this.openEdit(index, row)
    },
    checkboxChange (data, row, column) {
      const {prop} = column
      set(row, prop, data)
    },
    setPositionPopup (e, rowId, ref) {
      this.showPopup = rowId
      const popups = get(this.$refs, ref, '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      const {left, top} = box
      this.openPopup = {
        left: (left - diffLeft + 5) + 'px',
        top: top + 40 + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-approve-cell {
  @include global-font;
  position: relative;

  &-icons {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  &__button {
    padding: 8px 20px;
    max-height: 35px;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    color: $color-white;
  }

  &__icon {
    width: 21px;
    height: 21px;
    cursor: pointer;

    &_cursor {
      cursor: default;
    }
  }

  &__double {
    width: 21px;
    height: 21px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: $color-wild-sand;
    color: $color-accent;
    font-size: 11px;
    font-weight: 600;
    margin-left: 10px;
    cursor: pointer;
  }

  &-popup {
    display: grid;
    z-index: 2;
    grid-row-gap: 10px;
    max-width: 458px;
    position: fixed;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    color: black;
    padding: 12px;
    pointer-events: none;

    &__item {
      display: grid;
      grid-template-columns: 25px auto;
      grid-gap: 6px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;

      &_weight {
        font-weight: bold;
      }
    }

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/ApproveCell/ApproveCell.vue